<template>
  <section id="blog" class="py-20">
    <div class="max-w-6xl mx-auto px-6">
      <div class="text-center mb-12">
        <h2 class="text-3xl md:text-4xl font-bold mb-4" :class="isDark ? 'text-white' : 'text-gray-800'">
          <span :class="isDark ? 'text-gray-400' : 'text-gray-500'">// </span>技术博客
        </h2>
        <p :class="isDark ? 'text-gray-400' : 'text-gray-500'">分享技术见解和开发经验</p>
        <div class="w-20 h-1 bg-green-500 mx-auto mt-4"></div>
      </div>

      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div 
          v-for="post in posts.slice(0, 3)" 
          :key="post.id"
          class="rounded-xl overflow-hidden border transition-all group cursor-pointer"
          :class="isDark ? 'bg-gray-800 border-gray-700 hover:border-green-500/50' : 'bg-white border-gray-200 hover:border-green-500/50 shadow-sm'"
          @click="$router.push('/blog')"
        >
          <div class="p-6">
            <div class="flex items-center justify-between mb-4">
              <span class="px-3 py-1 text-xs rounded-full"
                    :class="isDark ? 'bg-green-500/20 text-green-400' : 'bg-green-100 text-green-600'">
                {{ post.category }}
              </span>
              <span class="text-xs" :class="isDark ? 'text-gray-500' : 'text-gray-400'">{{ post.date }}</span>
            </div>
            <h3 class="text-xl font-semibold mb-3 group-hover:text-green-400 transition-colors"
                :class="isDark ? 'text-white' : 'text-gray-800'">
              {{ post.title }}
            </h3>
            <p class="text-sm line-clamp-3 mb-4" :class="isDark ? 'text-gray-400' : 'text-gray-500'">{{ post.excerpt }}</p>
            <div class="flex items-center justify-between">
              <div class="flex items-center space-x-2">
                <img :src="post.avatar" :alt="post.author" class="w-6 h-6 rounded-full" />
                <span class="text-sm" :class="isDark ? 'text-gray-400' : 'text-gray-500'">{{ post.author }}</span>
              </div>
              <div class="flex items-center space-x-3 text-sm" :class="isDark ? 'text-gray-500' : 'text-gray-400'">
                <span class="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                  {{ post.views }}
                </span>
                <span class="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                  </svg>
                  {{ post.comments }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-8 text-center">
        <button @click="$router.push('/blog')" class="px-6 py-3 border rounded-lg transition-colors"
                :class="isDark ? 'border-gray-600 hover:border-green-500 hover:text-green-400 text-gray-300' : 'border-gray-300 hover:border-green-500 hover:text-green-600 text-gray-600'">
          查看更多文章
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { useTheme } from '../composables/useTheme'

export default {
  name: 'BlogSection',
  setup() {
    const { isDark } = useTheme()
    return { isDark }
  },
  data() {
    return {
      posts: [
        {
          id: 1,
          title: 'Vue 3 Composition API 完全指南',
          excerpt: '深入理解 Vue 3 的 Composition API，包括 ref、reactive、computed 等核心概念...',
          category: 'Vue.js',
          date: '2024-01-15',
          author: '潘志捷',
          avatar: 'https://api.dicebear.com/7.x/shapes/svg?seed=panzhijie',
          views: 2340,
          comments: 45
        },
        {
          id: 2,
          title: 'React Server Components 初探',
          excerpt: '探索 React Server Components 的工作原理，了解如何利用它提升应用性能...',
          category: 'React',
          date: '2024-01-12',
          author: '潘志捷',
          avatar: 'https://api.dicebear.com/7.x/shapes/svg?seed=panzhijie',
          views: 1890,
          comments: 32
        },
        {
          id: 3,
          title: 'Node.js 性能优化实战',
          excerpt: '分享 Node.js 应用性能优化的实用技巧，包括内存管理、异步处理...',
          category: 'Node.js',
          date: '2024-01-10',
          author: '潘志捷',
          avatar: 'https://api.dicebear.com/7.x/shapes/svg?seed=panzhijie',
          views: 3120,
          comments: 58
        }
      ]
    }
  }
}
</script>